import { ArrowRight, Check } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { MARKETING_FEATURES } from "../data/content";

export const MarketingSection = ({ onEnquire }) => (
  <section id="marketing" data-testid="marketing-section" className="noise-overlay relative overflow-hidden bg-navy-900 py-24 lg:py-32">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(212,175,55,0.06),transparent_50%)]" />
    <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-4 sm:px-8 lg:grid-cols-2 lg:px-16">
      <Reveal delay={0.15} className="order-2 lg:order-1">
        <div className="relative">
          <div aria-hidden="true" className="animate-spin-slow absolute -inset-8 rounded-full border border-dashed border-gold/15" style={{ animationDirection: "reverse" }} />
          <div className="sheen-border relative overflow-hidden rounded-[1.75rem] border border-gold/20">
            <img
              src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80"
              alt="Digital marketing analytics and growth dashboard on a laptop"
              className="h-[300px] w-full object-cover sm:h-[380px] lg:h-[460px]"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-950/85 via-navy-950/15 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold-soft">Reach · Engage · Convert</p>
              <p className="mt-2 max-w-sm font-display text-2xl font-semibold leading-snug text-slate-50">
                Marketing engineered around one metric: your growth.
              </p>
            </div>
          </div>
        </div>
      </Reveal>

      <div className="order-1 lg:order-2">
        <SectionHeading
          overline="Marketing & Advertising"
          testId="marketing-heading"
          title={
            <>
              Put your business in front of the <span className="text-gold-metallic italic">right customers</span>
            </>
          }
          description="Great businesses stay invisible without the right marketing. We build and run social media, advertising and digital strategies that get you seen, remembered and chosen — across the UAE and beyond."
        />
        <ul className="mt-10 space-y-4">
          {MARKETING_FEATURES.map((f, i) => (
            <Reveal key={f} delay={0.06 * i}>
              <li className="flex items-start gap-3.5 text-sm sm:text-base text-slate-300">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-gold/30 bg-gold/10">
                  <Check className="h-3.5 w-3.5 text-gold" />
                </span>
                {f}
              </li>
            </Reveal>
          ))}
        </ul>
        <Reveal delay={0.35}>
          <a
            href="#contact"
            data-testid="marketing-cta"
            onClick={() => onEnquire("Digital Marketing")}
            className="btn-gold mt-10 inline-flex items-center gap-2.5 rounded-full bg-gold px-8 py-4 text-sm font-semibold text-navy-950 transition-[box-shadow,transform] duration-400 hover:-translate-y-1 hover:shadow-[0_18px_50px_-10px_rgba(212,175,55,0.55)]"
          >
            Grow My Reach
            <ArrowRight className="h-4 w-4" />
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
